module.exports = __webpack_public_path__ + "static/img/create03.b233f08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/create03.svg
// module id = hf8C
// module chunks = 3